import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LayoutDashboard, Upload, FolderOpen, Users, Copy, LogOut, Merge as MergeIcon, Send, Settings as SettingsIcon, Activity as ActivityIcon } from "lucide-react";

const LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/cb57efd0-2bdc-4109-9706-5ee332c3bb0a/images/cd582a59b1cfc3728cb48e6f787fe6830bba8a8dd2587c87f5b872f3bcb2979a.png";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/upload", label: "Upload", icon: Upload, testid: "nav-upload" },
  { to: "/merge", label: "Merge Files", icon: MergeIcon, testid: "nav-merge" },
  { to: "/files", label: "Files", icon: FolderOpen, testid: "nav-files" },
  { to: "/leads", label: "Leads", icon: Users, testid: "nav-leads" },
  { to: "/duplicates", label: "Duplicates", icon: Copy, testid: "nav-duplicates" },
  { to: "/send", label: "Send Email", icon: Send, testid: "nav-send" },
  { to: "/activity", label: "Activity", icon: ActivityIcon, testid: "nav-activity" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-[#F7F7F8]" data-testid="app-shell">
      {/* Sidebar */}
      <aside className="w-60 shrink-0 border-r border-gray-200 bg-white flex flex-col">
        <div className="px-5 py-5 border-b border-gray-200 flex items-center gap-3">
          <img src={LOGO_URL} alt="Omnilink" className="h-8 w-8" />
          <div>
            <div className="font-display font-bold text-gray-950 leading-tight">Omnilink</div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-gray-500">Lead Portal</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map(({ to, label, icon: Icon, testid, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-all duration-200 ${
                  isActive
                    ? "bg-[#002FA7] text-white"
                    : "text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              <Icon size={16} />
              <span className="font-medium">{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-gray-200">
          <div className="px-3 py-2 mb-2">
            <div className="text-[10px] tracking-[0.18em] uppercase text-gray-500">Signed in</div>
            <div className="text-sm text-gray-900 font-medium truncate" data-testid="user-email">{user?.email}</div>
          </div>
          <button
            onClick={onLogout}
            data-testid="logout-button"
            className="w-full flex items-center gap-2 px-3 py-2 rounded-sm text-sm text-gray-700 hover:bg-gray-100 transition-all"
          >
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
